import React from 'react';
import CopySection from '../CopySection';
import styles from './PaymentPanel.module.scss';
import { AlarmClockIcon, CreditCardIcon, SunriseIcon } from '@repo/icons';
import { capitalize } from '@repo/utils/helpers/string';
import { ClayProduct } from '.';

const iconColor = 'rgba(255,255,255,0.8)';

export default function ProductPlanCopy({
  product,
  cadence,
}: {
  product: ClayProduct;
  cadence: 'year' | 'month';
}) {
  const featuresStr = `all Clay ${capitalize(product.name)} features`;
  return (
    <CopySection>
      <h2>How your free trial works</h2>
      <div className={styles.step}>
        <div className={styles.icon}>
          <SunriseIcon customColor={iconColor} />
        </div>
        <h4>Today</h4>
        <p>
          Full access to{' '}
          {window.desktopIntegrations?.appInfo.isMAS ? (
            <>{featuresStr}</>
          ) : (
            <a href="https://clay.earth/pricing" target="_blank">
              {featuresStr}
            </a>
          )}
          . Cancel any time and enjoy Clay's free features.
        </p>
      </div>
      <div className={styles.step}>
        <div className={styles.icon}>
          {/* <NavRemindersIcon width="7.5" color="textSecondary" /> */}
          <AlarmClockIcon customColor={iconColor} />
        </div>
        <h4>Day {product.trialDaysLeft - 3}</h4>
        <p>We will send you an e-mail reminder 3 days before your free trial expires.</p>
      </div>
      <div className={styles.step}>
        <div className={styles.icon}>
          <CreditCardIcon customColor={iconColor} />
        </div>
        <h4>Day {product.trialDaysLeft}</h4>
        <p>
          You'll be billed{' '}
          <b>
            ${product.plans[cadence].price}/{cadence}
            {product.name === 'teams' ? ' per team member' : ''}
          </b>{' '}
          for the {capitalize(product.name)} plan.
          {!window.desktopIntegrations?.appInfo.isMAS && (
            <>
              {' '}
              <a href="https://go.clay.earth/free-trial-faq" target="_blank">
                Learn why we require credit cards
              </a>
              .
            </>
          )}
        </p>
      </div>
    </CopySection>
  );
}
